import React from 'react';
import BarChartIcon from '@mui/icons-material/BarChart';
import EditIcon from '@mui/icons-material/Edit';
import RefreshIcon from '@mui/icons-material/Refresh';
import SaveIcon from '@mui/icons-material/Save';
import TableChartIcon from '@mui/icons-material/TableChart';
import TuneIcon from '@mui/icons-material/Tune';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import { REFINE_MODES } from './ChatMessage.service';

export default function MessageActionButtons({
  hasSql,
  hasChartSpec,
  hasData,
  chartVisible,
  isLoadingData,
  isGeneratingChart,
  isRefiningChart,
  isRefreshingData,
  refineMode,
  canRefineQuery,
  canRefineChart,
  onLoadData,
  onGenerateChart,
  onToggleChartVisible,
  onOpenRefine,
  onSaveChart
}) {
  return (
    <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
      {!hasData && hasSql && (
        <Button
          size="small"
          variant="outlined"
          startIcon={isLoadingData ? <CircularProgress size={16} /> : <TableChartIcon />}
          onClick={onLoadData}
          disabled={isLoadingData || isRefreshingData}
        >
          {isLoadingData ? 'Loading...' : 'Show Dataset'}
        </Button>
      )}
      {!hasChartSpec && hasSql && (
        <Button
          size="small"
          variant="outlined"
          startIcon={isGeneratingChart ? <CircularProgress size={16} /> : <BarChartIcon />}
          onClick={onGenerateChart}
          disabled={isGeneratingChart}
        >
          {isGeneratingChart ? 'Generating...' : 'Generate Chart'}
        </Button>
      )}
      {hasChartSpec && (
        <Button
          size="small"
          variant="outlined"
          startIcon={chartVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
          onClick={onToggleChartVisible}
        >
          {chartVisible ? 'Hide Chart' : 'Show Chart'}
        </Button>
      )}
      {hasChartSpec && hasSql && (
        <Button
          size="small"
          variant="outlined"
          startIcon={isGeneratingChart ? <CircularProgress size={16} /> : <RefreshIcon />}
          onClick={onGenerateChart}
          disabled={isGeneratingChart}
        >
          {isGeneratingChart ? 'Regenerating...' : 'Regenerate Chart'}
        </Button>
      )}
      {hasSql && canRefineQuery && (
        <Button
          size="small"
          variant="outlined"
          startIcon={<EditIcon />}
          onClick={() => onOpenRefine(REFINE_MODES.QUERY)}
          disabled={refineMode === REFINE_MODES.QUERY}
        >
          Refine Query
        </Button>
      )}
      {hasChartSpec && canRefineChart && (
        <Button
          size="small"
          variant="outlined"
          startIcon={isRefiningChart ? <CircularProgress size={16} /> : <TuneIcon />}
          onClick={() => onOpenRefine(REFINE_MODES.CHART)}
          disabled={refineMode === REFINE_MODES.CHART || isRefiningChart}
        >
          Refine Chart
        </Button>
      )}
      {hasChartSpec && (
        <Button size="small" variant="outlined" startIcon={<SaveIcon />} onClick={onSaveChart}>
          Save Chart
        </Button>
      )}
    </Box>
  );
}
